export var UserStatusVoData;
(function (UserStatusVoData) {
    UserStatusVoData["ONLINE"] = "online";
    UserStatusVoData["AWAY"] = "away";
    UserStatusVoData["BUSY"] = "busy";
    UserStatusVoData["INVISIBLE"] = "invisible";
    UserStatusVoData["OFFLINE"] = "offline";
})(UserStatusVoData || (UserStatusVoData = {}));
//# sourceMappingURL=user-status-vo-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/vo/user/user-status-vo-data.js
// module id = 402
// module chunks = 14